/**
 * Utility for handling hash-based navigation within the same page
 * Have to use it to fix problem with tag <base href="/"> in the index.html
 * When we have that tag (<base href="/">), the anchor (a) tag not respecting the standard # link behavior.
 * It will be redirected to the root of the page (not including the pathname).
 */

function navigateToHash(href: string) {
    const { origin, pathname, search } = window.location;
    window.location.href = `${origin}${pathname}${search}${href}`;
}

export function handleHashNavigation(e: MouseEvent) {
    const anchor = e?.currentTarget as HTMLAnchorElement;
    const href = anchor?.getAttribute("href");

    if (href?.startsWith("#")) {
        e.preventDefault();
        navigateToHash(href);
    }
}

export function handleDelegatedHashNavigation(e: MouseEvent) {
    const anchor = (e.target as HTMLElement).closest("a");
    if (!anchor) {
        return;
    }

    const href = anchor.getAttribute("href");
    if (href?.startsWith("#")) {
        e.preventDefault();
        navigateToHash(href);
    }
}
